import React from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './theme';
import { Route, Routes } from 'react-router-dom';
import AdminView from './features/admin/AdminView';
import AdminWrapper from './common/components/AdminWrapper';
import ApplicantsView from './features/admin/ApplicantsView/ApplicantsView';
import ApplicantWrapper from './common/components/ApplicantWrapper';
import SettingsView from './features/admin/settings/SettingsView';
import Notification from './common/components/Notification';
import CategoryView from './features/admin/questions/CategoriesView/CategoryView';
import ConfirmationDialog from './common/components/ConfirmationDialog';
import QuestionsView from './features/admin/questions/QuestionsView/QuestionsView';
import ApplicantLandingPage from './features/applicant/ApplicantLandingPage';
import TestView from './features/applicant/TestView/TestView';
import ScoreView from './features/admin/ApplicantsView/ScoreView';

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route path="/">
          <Route element={<ApplicantWrapper />}>
            <Route index element={<ApplicantLandingPage />} />
            <Route path="test" element={<TestView />} />
            <Route path="test/:categoryId" element={<TestView />} />
            <Route path="test/:categoryId/:questionIndex" element={<TestView />} />
          </Route>
          <Route path="admin" element={<AdminWrapper />}>
            <Route index element={<AdminView />} />
            <Route path="applicants">
              <Route index element={<ApplicantsView />} />
              <Route path=":attemptId" element={<ScoreView />} />
            </Route>
            <Route path="categories">
              <Route index element={<CategoryView />} />
              <Route path=":categoryId" element={<QuestionsView />} />
            </Route>
            <Route path="settings" element={<SettingsView />} />
          </Route>
        </Route>
      </Routes>
      <Notification />
      <ConfirmationDialog />
    </ThemeProvider>
  );
};

export default App;
